import { Button, Grid, MenuItem, Select, TextField, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import { NodeStatus, NodeTypeName, Node } from '../../domain/domain';
import { ALL_NODE_TYPES, getNodeTypeNameText } from '../ComponentManagementPage/utils';
import { addChildNode } from '../../api/node';
import { useDispatch } from 'react-redux';
import { UiActionType } from '../../reducers/ui.reducer';

const OpsCreateNodeTool : React.FC = () => {
    
    const [parentId, setParentId] = useState<string>("");
    const [nodeType, setNodeType] = useState<NodeTypeName>(NodeTypeName.SECTION);
    const [heading, setHeading] = useState<string>("");
    const [status, setStatus] = useState<NodeStatus>(NodeStatus.CHANGED_NOT_APPROVED);
    const [citation, setCitation] = useState<string>("");
    const dispatch = useDispatch();

    const isFormValid = () => {
        if (!parentId) {
            return false;
        }
        if (!heading) {
            return false;
        }
        return true;
    }

    return (
        <Grid container direction='column' className="flex-gap-2">
            <Grid item>
                <Typography variant='h2'>Create a new node</Typography>
            </Grid>
            <Grid item>
                <TextField variant='outlined' size='small' label='Parent Id'  InputLabelProps={{shrink: true}} value={parentId} onChange={(event) => {
                    setParentId(event.target.value);
                }}></TextField>
            </Grid>
            <Grid item>
                <TextField size='small' label='Heading' variant='outlined'  InputLabelProps={{shrink: true}} value={heading} onChange={(event) => {
                    setHeading(event?.target.value);
                }}></TextField>
            </Grid>
            <Grid item>
                <TextField size='small' label='Citation' variant='outlined'  InputLabelProps={{shrink: true}} value={citation} onChange={(event) => {
                    setCitation(event?.target.value);
                }}></TextField>
            </Grid>
            <Grid item>
                <Select placeholder='Node Status' variant='outlined' value={status} onChange={(event: any) => {
                    setStatus(event.target.value as NodeStatus);
                }}>
                    <MenuItem value={NodeStatus.CHANGED_NOT_APPROVED}>Changed Not Approved</MenuItem>
                    <MenuItem value={NodeStatus.APPROVED}>Approved</MenuItem>
                </Select>
            </Grid>
            <Grid item>
                <Select placeholder='Node Type' variant='outlined' value={nodeType} onChange={(event: any) => {
                    setNodeType(event.target.value as NodeTypeName);
                }}>
                    {ALL_NODE_TYPES.map(nodeType => {
                        return (
                            <MenuItem value={nodeType}>{getNodeTypeNameText(nodeType)}</MenuItem>
                        )
                    })}
                </Select>
            </Grid>
            <Grid item>
                <Button color='primary' disabled={!isFormValid()} variant='contained' onClick={() => {
                    let node : Node = {
                        nodeId: 0,
                        parentId: parseInt(parentId),
                        status: status,
                        heading: heading,
                        citation: citation,
                        editorialContent: [],
                        nodeType: nodeType,
                        citationPart: "",
                        content: "",
                        hasUnapprovedEditorialContent: false,
                        markedForDeletion: false,
                        repealed: false,
                        belowEditorialLevel: false,

                    }
                    addChildNode(parseInt(parentId), node).then(response => {
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Node added", severity: "success" } });
                    }).catch(error => {
                        dispatch({ type: UiActionType.SNACKBAR_STATE_CHANGED, newState: { open: true, message: "Could not add node", severity: "error" } });
                    })
                }}>Create</Button>
            </Grid>
        </Grid>
    )
}

export default OpsCreateNodeTool;